export class AutoLockRequestDecisionModel {
    TransactionId: string;
    FeatureType: string;
    IpAddress: string;
    RecipientKey: string;
  }
//   export class AutoLockDecisionResultContent {
//     RequestsCount: number;
//     RequestStatus: number;
//   }
  
export class AutoLockDecisionResponse {
    status: string;
    statusCode: number;
    statusText: string;
    success: boolean;
    message: AutoLockDecisionMessage;
    resultContent: AutoLockDecisionResultContent;
  }
  
  export class AutoLockDecisionMessage {
    message: string;
    messageCode: string;
  }
  
  export class AutoLockDecisionResultContent {
    requestsCount: number | null;
    requestStatus: number | null;
  }
  export class AccessDecision {
    Id:string;
    Feature: string;
    Ip: string;
    Key: string;
    RiskLevel: number;
    City: string;
    Region: string;
    RegionCode: string;
    CountryCode: string;
    CountryName: string;
    Network: string;
    Latitude: string;
    Longitude: string;
    Count : number;
    Status : number;
    Lang : string;
    RefUrl : string;
  }
  
  